import React from 'react';
import { getBrowserTimezone } from './calendarTimezoneUtils';

const SHORT_EVENT_MAX_MINUTES = 30;

export const normalizeEvent = (event) => ({
  id: String(event.id || event.web_id),
  title: event.title,
  start: event.start || event.starts_at,
  end: event.end || event.ends_at,
  extendedProps: {
    reminders: event.reminders || []
  }
});

export const computeScrollTime = () => {
  const hour = Math.max(new Date().getHours() - 1, 0);
  return `${String(hour).padStart(2, '0')}:00:00`;
};

export const buildShowEventPayload = (event) => ({
  id: event.id,
  title: event.title,
  start: event.start?.toISOString(),
  end: event.end?.toISOString(),
  reminders: event.extendedProps?.reminders || []
});

export const buildPersistEventPayload = (event) => ({
  title: event.title,
  starts_at: event.start?.toISOString(),
  ends_at: (event.end || event.start)?.toISOString(),
  timezone: getBrowserTimezone()
});

export const getEventDurationMinutes = (event) => {
  if (!event?.start || !event?.end) return null;

  const durationMs = event.end.getTime() - event.start.getTime();
  return durationMs > 0 ? durationMs / 60000 : null;
};

export const getEventContentVariant = (durationMinutes) => (
  durationMinutes !== null && durationMinutes < SHORT_EVENT_MAX_MINUTES ? 'short' : 'regular'
);

export const renderCompactEventContent = (arg) => {
  const durationMinutes = getEventDurationMinutes(arg.event);
  const variant = getEventContentVariant(durationMinutes);
  const isShort = variant === 'short';

  return (
    <div className={`fc-mercately-event-block fc-mercately-event-block-${variant}`}>
      <p className="fc-mercately-event-title">{arg.event.title}</p>
      {!isShort && arg.timeText && <p className="fc-mercately-event-time">{arg.timeText}</p>}
    </div>
  );
};
